    // const baseURL = "https://api.bigdaddyexch.co/api";
    // const baseURL = "https://api.hubs98.com/api";
    // const baseURL = "https://api.radhe99.in/api"; 
   
    const baseURL = "https://api.sixerexch.net/api"; 
   
    const socketConnectionURL = "https://api.sixerexch.net";
    export{socketConnectionURL}
    export default baseURL;
